(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-samplers"] && !Shopify.designMode) return;
  try {
    class ProductSamplers extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.product-samplers__button').forEach((button) => {
      button.addEventListener('click', this.handleSamplerClick.bind(this));
    });
  }

  handleSamplerClick(e) {
    const button = e.currentTarget;
    const target = button.getAttribute('data-target');
    const isActive = button.classList.contains('product-samplers__button--active');

    if (isActive) {
      button.classList.remove('product-samplers__button--active');
      button.setAttribute('aria-pressed', 'false');
      const targetElement = document.getElementById(target);
      if (targetElement) targetElement.disabled = true;
    } else {
      button.classList.add('product-samplers__button--active');
      button.setAttribute('aria-pressed', 'true');
      const targetElement = document.getElementById(target);
      if (targetElement) targetElement.removeAttribute('disabled');
    }

    this.updateExternalElements();

    // Dispatch custom event for form to listen to
    this.dispatchEvent(new CustomEvent('sampler-changed', {
      bubbles: true,
      detail: { activeCount: this.getActiveCount() }
    }));
  }

  updateExternalElements() {
    const activeCount = this.getActiveCount();

    // Update external form elements based on selection
    const colorsElement = document.getElementById('colors');
    if (colorsElement) {
      colorsElement.disabled = activeCount > 0;
    }

    const colornoteElement = document.getElementById('colornote');
    if (colornoteElement) {
      colornoteElement.style.display = activeCount > 0 ? 'none' : 'block';
    }
  }

  getActiveCount() {
    return document.querySelectorAll('.product-samplers__button--active').length;
  }

  // Public method for form to check if samplers are selected
  hasSelection() {
    return this.getActiveCount() > 0;
  }
}

customElements.define('product-samplers', ProductSamplers);
  } catch(e) { console.error(e); }
})();

})();
